import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { v4 as uuidv4 } from 'uuid';
import { agregarFC_01AnexoMedioDeContactoBeneficiario, actualizarEstadoFC_01AnexoMediosDeContactoBeneficiario, agregarFC_01AnexoMediosDeContactoBeneficiario, editarFC_01AnexoMediosDeContactoBeneficiario, eliminarFC_01AnexoMedioDeContactoBD } from '../../redux/DucksBeneficiario/FC_01Ducks'
import estilos from './TelefonoYCorreo.module.css'
import { useStateIfMounted } from 'use-state-if-mounted'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
library.add(faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faCannabis, faClover, faHandSpock,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster, faBoxOpen, faDumpsterFire, faXmark)
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faCannabis, faClover, faHandSpock,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster, faBoxOpen, faDumpsterFire, faXmark
} from '@fortawesome/free-solid-svg-icons'
import {
    agregarFC_01TelefonoYCorreoMap
} from '../../redux/DucksAtencionACliente/FC_01AtencionAClienteDucks';

import ModalComponent from './ModalComponent'

const { useState, useEffect, useRef } = React;

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const TelefonoYCorreo = (props) => {
    const dispatch = useDispatch()
    const [observacionesMedios, setObservacionesMedios] = useStateIfMounted(props.observacionesMedios);
    
    const usuario = useSelector(store => store.Usuario)
    const idUsuario = usuario.data.user[0].id
    const modoCorreccion = useSelector(store => store.FC_01Solicitud.modoCorreccion)
    let mediosDeContacto = props.mediosDeContacto
    //alert(JSON.stringify(mediosDeContacto));
    const componente = props.componente
    const map = props.map


    const tipoUsuario = useSelector(store => store.Usuario.tipoUsuario)

    const actualizarObservacionesMedios = (data) => {
        const nuevoObservacionMedios = observacionesMedios.filter(field => field.id === data.id)
        nuevoObservacionMedios[0][data.campo] = data.valor

        let campo = data.campo.replace('check', '')
        if (data.valor) {
            handleOpenModalObservaciones()
            mostrarModal({ id: data.id, campo: campo, anexo: 'mediosContacto' })
        } else {
            nuevoObservacionMedios[0][campo] = ''
        }
        setObservacionesMedios([...observacionesMedios]);
        // dispatch(agregarFC_01TelefonoYCorreoMap(observacionesMedios))
    }

    const [openModalObservaciones, setOpenModalObservaciones] = React.useState(false);
    const handleOpenModalObservaciones = () => setOpenModalObservaciones(true);
    const handleCloseModalObservaciones = () => setOpenModalObservaciones(false);

    const handleCloseModalObservacionesX = () => {
        setOpenModalObservaciones(false);

        desactivarCheck(campoParaObservacion);
    }
    const [observacionArea, setObservacionArea] = useStateIfMounted('')
    let [campoParaObservacion, setCampoParaObservacion] = useStateIfMounted('')
    const mostrarModal = (campo) => {
        setCampoParaObservacion(campo)
    }
    const modalComponentObservaciones = (campo) => {
        return (
            <Fragment>
                <Modal
                    open={openModalObservaciones}
                    onClose={handleCloseModalObservacionesX}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    disableEnforceFocus
                >
                    <Box sx={style}>
                        <div className={`${estilos.textRight}`}>
                            <button className='btn' onClick={handleCloseModalObservacionesX}>
                                <FontAwesomeIcon icon={faXmark} />
                            </button>
                        </div>

                        <div align="center">
                            <label align="center"> <b>OBSERVACIONES</b></label>
                        </div>

                        <textarea type="textarea" rows="3" className="form-control"
                            placeholder='Detalle de la observacion.'
                            value={observacionArea} onChange={e => setObservacionArea(e.target.value)} />

                        <br />
                        <div className="d-grid gap-2 d-md-flex justify-content-md-center">
                            <button className='btn btn-dark' onClick={e => botonGuardarObservaciones(observacionArea)}>Aceptar</button>
                        </div>

                    </Box>
                </Modal>
            </Fragment>

        )
    }
    const botonGuardarObservaciones = async (observacion) => {

        switch (campoParaObservacion.anexo) {
            
            case 'mediosContacto':
                const nuevoObservacionMedio = observacionesMedios.filter(field => field.id === campoParaObservacion.id)
                // let campos = campoParaObservacion.campo
                nuevoObservacionMedio[0][campoParaObservacion.campo] = observacion
                setObservacionesMedios([...observacionesMedios])
                props.history.push('/fc_01',  {observacionesMedios:observacionesMedios} )
                //dispatch(agregarFC_01TelefonoYCorreoMap(observacionesMedios))
                break;
            default:
                break

        }
        handleCloseModalObservaciones()
        setObservacionArea('')
        setCampoParaObservacion('')
    }

    const modoEdicionBorrador = useSelector(store => {
        switch (componente) {
            case 'fc_01':
                return store.FC_01Solicitud.modoEdicionBorrador
            default:
                break;
        }
    })
    const deleteMedioDeContacto = (inputField) => {
        const fields = mediosDeContacto.filter(fields => fields.id !== inputField.id)
        mediosDeContacto = fields
        switch (componente) {
            case 'fc_01':
                if (inputField.idfc01_anexomediosdecontacto) {
                    dispatch(eliminarFC_01AnexoMedioDeContactoBD(inputField.idfc01_anexomediosdecontacto))
                }
                dispatch(agregarFC_01AnexoMediosDeContactoBeneficiario({ data: fields }))
                break;
            default:
                break;
        }
    }

    const handleAddMedioDeContacto = async () => {
        let anexo = { id: uuidv4(), telefono: '', correoelectronico: '', estado: false }
        if (modoEdicionBorrador) {
            switch (componente) {
                case 'fc_01':
                    dispatch(agregarFC_01AnexoMedioDeContactoBeneficiario(anexo))
                    break;
                default:
                    break;
            }
        } else {
            mediosDeContacto = ([...mediosDeContacto, anexo])
            switch (componente) {
                case 'fc_01':
                    dispatch(agregarFC_01AnexoMediosDeContactoBeneficiario({ data: mediosDeContacto }))
                    break;
                default:
                    break;
            }
        }

    };

    const handleOnChangueMedioDeContacto = (data) => {

        switch (componente) {
            case 'fc_01':
                dispatch(editarFC_01AnexoMediosDeContactoBeneficiario(data))
                break;
            default:
                break;
        }


    }

    const [isValid, setIsValid] = useState(false);
    const [message, setMessage] = useState('');
    //const emailRegex = /\S+@\S+\.\S+/;
    let emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const escapeRegExpMatch = function (s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    };

    const isExactMatch = (str, match) => {
        return new RegExp(`\\b${escapeRegExpMatch(match)}\\b`).test(str)
    }

    const validateEmail = (event, inputField) => {

        const email = event.target.value;
        comprobarEmail(email, inputField);

    };

    function comprobarEmail(correo, inputField) {
        const patron = /^[^ ]+@[^ ]+\.[a-z]{2,3}$/;
        const emailsAceptados = ['@gmail', '@yahoo', '@outlook', '@hotmail'];
        const extensionesAceptadas = ['.mx', '.com', '.es'];

        let isEmailAceptadoFlag = false;
        let isExtensionAceptadaFlag = false;

        if (correo.match(emailRegex)) {
          
            isEmailAceptadoFlag = true;
            isExtensionAceptadaFlag = true;

            if (isEmailAceptadoFlag === true && isExtensionAceptadaFlag === true) {
                dispatch(actualizarEstadoFC_01AnexoMediosDeContactoBeneficiario({
                    id: inputField.id,
                    estado: true
                }))
            }
            else {
                dispatch(actualizarEstadoFC_01AnexoMediosDeContactoBeneficiario({
                    id: inputField.id,
                    estado: false
                }))
            }
        }
        else {

            dispatch(actualizarEstadoFC_01AnexoMediosDeContactoBeneficiario({
                id: inputField.id,
                estado: false
            }))
        }

    }


    return (
        <div>
            {
                mediosDeContacto.map((inputField, index) => (
                    <div key={index} className='row'>
                        <div className='col-md-6'>
                            <div className="form-floating mb-3 textoNegro" >
                                <input type="number"
                                    onChange={e => e.target.value.length < 11 ? (
                                        handleOnChangueMedioDeContacto(
                                            {
                                                valor: e.target.value,
                                                id: inputField.id,
                                                campo: 'telefono'
                                            })) : ''}
                                    value={inputField.telefono}
                                    className={`form-control ${map?.[index]?.telefonocheck !== undefined ? (
                                        map[index]?.telefonocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                    id="" placeholder='Teléfono'
                                />
                                <label className='label-dark' htmlFor="floatingInput" >Teléfono</label>
                                <span className='text-danger'>{map?.[index]?.telefono}</span>
                                {inputField.telefono.length<10?(<span className='text-danger'>Campo obligatorio</span>):''}
                            </div>
                        </div>
                        {
                            tipoUsuario === 3 &&
                            <div className={'col-md-1'}>
                                <br />
                                <input className={`form-check-input me-1 mb-3 ${estilos.escalar}`} type="checkbox"
                                    value={observacionesMedios[index].telefonocheck}
                                    onChange={e => actualizarObservacionesMedios({ valor: e.target.checked, id: observacionesMedios[index].id, campo: 'telefonocheck' })}
                                    checked={observacionesMedios[index].telefonocheck}
                                />
                            </div>
                        }
                        <div className='col-md-5'>
                            <div className="form-floating mb-3">
                                <input type="email"
                                    className={`form-control ${map?.[index]?.correoelectronicocheck !== undefined ? (
                                        map[index]?.correoelectronicocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                    onChange={(e) => {
                                        validateEmail(e, inputField),
                                            handleOnChangueMedioDeContacto(
                                                {
                                                    valor: e.target.value,
                                                    id: inputField.id,
                                                    campo: 'correoelectronico',
                                                })
                                    }}
                                    value={inputField.correoelectronico}
                                    id="" placeholder='ejemplo@gmail.com'
                                />

                                <label htmlFor="floatingInput" className='label-dark'>Correo electrónico</label>
                                {inputField.correoelectronico.length===0?(<span className='text-danger'>Campo obligatorio</span>):''}
                                <div key={index} className={`message ${inputField.estado ? estilos.success : estilos.error}`}>

                                    {inputField.estado ? `Correo Válido` : `Verifique la estructura de su correo `}
                                </div>
                                <span className='text-danger'>{map?.[index]?.correoelectronico}</span>

                            </div>
                        </div>
                        {
                            tipoUsuario === 3 &&
                            <div className={'col-md-1'}>
                                <br />

                                <input className={`form-check-input me-1 mb-3 ${estilos.escalar}`} type="checkbox"
                                    value={observacionesMedios[index].correoelectronicocheck}
                                    onChange={e => actualizarObservacionesMedios({ valor: e.target.checked, id: observacionesMedios[index].id, campo: 'correoelectronicocheck' })}
                                    checked={observacionesMedios[index].correoelectronicocheck}
                                />
                            </div>
                        }

                        {
                            tipoUsuario !== 3 ?
                                (<Fragment>
                                    {
                                        !modoCorreccion &&
                                        <div className='mt-2 col-md-1 border-secondary'>
                                            <ModalComponent api={{ deleteAnexo: deleteMedioDeContacto, inputField }} text="un medio de contacto" />
                                        </div>
                                        // <div className='row justify-content-md-end mb-2 mt-2'>
                                        
                                    }
                                </Fragment>) : ''
                        }


                    </div>
                ))
            }
            {modalComponentObservaciones(campoParaObservacion)}
            {
                tipoUsuario !== 3 ?
                    (<Fragment>
                        {
                            !modoCorreccion &&
                            <div className='text-center'>
                                <button className='botonAgregarAnexo mb-2 mt-2'
                                    onClick={e =>
                                        handleAddMedioDeContacto()}
                                >Agregar teléfono y correo</button>
                            </div>
                        }
                    </Fragment>) : ''
            }

        </div>
    )
};

export default withRouter(TelefonoYCorreo)
